module.exports = __webpack_public_path__ + "img/pie-de-logotipos.fb80d91b.png";